module.exports = __webpack_public_path__ + "img/undraw_access_denied_re_awnf.a81b544a.svg";